import { Box, Flex, Text, Link } from "@chakra-ui/react";
import ButtonMailto from "./Mailto";
import { motion } from "framer-motion";
import React from "react";

const Resume = () => {
  const downloadLink = () => {
    fetch("GRACYPATEL_RESUME.pdf").then((response) => {
      response.blob().then((blob) => {
        const fileURL = window.URL.createObjectURL(blob);
        let alink = document.createElement("a");
        alink.href = fileURL;
        alink.download = "GRACYPATEL_RESUME.pdf";
        alink.click();
      });
    });
  };
  return (
    <Box p={4}>
      <motion.div
        className="box"
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{
          duration: 0.8,
          delay: 0.5,
          ease: [0, 0.71, 0.2, 1.01],
        }}
      >
        <Flex align={"center"} justifyContent={"flex-end"}>
          <Text fontSize={{ base: "2xl", sm: "lg", md: "xl" }}>
            <ButtonMailto label="E-mail" mailto="mailto:gracy1168@gmail.com" />
            &nbsp; | &nbsp;{" "}
            <Link
              href="https://www.linkedin.com/in/gracy-patel-1144ba1b0/"
              target="_blank"
              rel="noreferrer"
            >
              <Text as={"span"} color={"blue.400"}>
                LinkedIn
              </Text>
            </Link>{" "}
            &nbsp; | &nbsp;{" "}
            <Link
              href="https://github.com/gracyspatel"
              target="_blank"
              rel="noreferrer"
            >
              {" "}
              <Text as={"span"} color={"blue.400"}>
                Github
              </Text>
            </Link>{" "}
            &nbsp; | &nbsp;{" "}
            <Link onClick={downloadLink}>
              <Text as={"span"} color={"blue.400"}>
                PDF
              </Text>
            </Link>
          </Text>
        </Flex>
        <hr style={{ marginTop: "20px", marginBottom: "20px" }} />
        <Box>
          <Text as="b" fontSize={{ base: "3xl", sm: "xl", md: "2xl" }}>
            AIM
          </Text>
          <br />
          <Text
            fontSize={{ base: "xl", sm: "lg", md: "lg" }}
            textAlign={"justify"}
          >
            A dedicated Software Engineer pursuing a degree in Computer Science
            & Engineering, looking for securing a position in a company in-order
            to efficiently contribute towards the growth of an organization.
          </Text>
          <hr style={{ marginTop: "20px", marginBottom: "20px" }} />
          <Text as="b" fontSize={{ base: "3xl", sm: "xl", md: "2xl" }}>
            SKILLS
          </Text>
          <br />
          <br />
          <Text fontSize={{ base: "xl", sm: "lg", md: "lg" }}>
            <Text as="b">Technical Skills:</Text> &nbsp; C, C++, JavaScript,
            Python,Java,OOPS, Data Structure and Algorithm, DBMS, Data
            Visualization, Web Scrapping, Linux
            <br />
            <Text as="b"> Databases: </Text> &nbsp;MongoDB, MySQL, PostgreSql
            <br />
            <Text as="b"> Developer Tools: </Text> &nbsp; VS Code, Google
            Collab,Google Data Studio, GitHub, Anaconda: Jupyter <br />
            <Text as="b"> Technologies/Frameworks: </Text> &nbsp; ReactJS,
            Redux,NodeJS, ExpressJS, NextJS, Flask, Git <br />
            <Text as="b"> Soft Skills: </Text> &nbsp; Presentation, Analytical,
            Teamwork, Problem-solving <br />
            <Text as="b"> Communication:</Text> &nbsp; English,Hindi,Gujarati
            <br />
          </Text>
          <hr style={{ marginTop: "20px", marginBottom: "20px" }} />

          <Text as="b" fontSize={{ base: "3xl", sm: "xl", md: "2xl" }}>
            EDUCATION
          </Text>
          <br />
          <br />
          <Text
            fontSize={{ base: "xl", sm: "lg", md: "lg" }}
            textAlign={"justify"}
          >
            Bachelor's in Computer Science & Engineering, Charusat University
          </Text>
          <Text
            fontSize={{ base: "xl", sm: "lg", md: "lg" }}
            textAlign={"justify"}
          >
            10th & 12th (PCM, Computer Science) Grade Schooling, Saraswati
            International School
          </Text>
          <hr style={{ marginTop: "20px", marginBottom: "20px" }} />

          <Text as="b" fontSize={{ base: "3xl", sm: "xl", md: "2xl" }}>
            EXPERIENCE
          </Text>
          <br />
          <br />
          <Text
            fontSize={{ base: "xl", sm: "lg", md: "lg" }}
            textAlign={"justify"}
          >
            <Text as="b">Avea Media pvt. ltd</Text> [ 06 2021 – 07 2021 ]
            Front-end react developer Ahmedabad, Gujarat
            <br />
            <ul style={{ marginLeft: "40px" }}>
              <li>
                Worked on developing a creative and interactive dashboard on the
                company’s on-going data-visualization project.
              </li>
              <li>
                Designed front-end in ReactJS with the help of front-end library
                materialUI and chartJS.
              </li>
            </ul>
            <Text as="b">Learn For Cause </Text> [ 05 2021 – 07 2021 ] Web
            Developer Bhuvneshwar, Odisha <br />
            <ul style={{ marginLeft: "40px" }}>
              <li>
                {" "}
                Worked with a community platform aiming at proving the learners
                training and workshops to empower students.
              </li>
              <li>
                {" "}
                Worked on designing and developing a blog site for the company
                using JavaScript framework NextJS under the guidance of project
                lead and manager.
              </li>
              <li>
                {" "}
                Created APIs in ExpressJS and front-end react components using
                NextJS.
              </li>
            </ul>
            <Text as="b">Skyttus </Text> [ 06 2022 – 07 2022 ] Front-end
            Developer Valsad, Gujarat
            <br />
            <ul style={{ marginLeft: "40px" }}>
              <li>
                Worked with a start-up founded in 2020 which aims at providing
                excellence in different applications and the cloud computing
                needs and here we learned and worked on React, React-redux.
              </li>
            </ul>
          </Text>
          <hr style={{ marginTop: "20px", marginBottom: "20px" }} />
        </Box>
      </motion.div>
    </Box>
  );
};

export default Resume;
